import React from "react";
import { Container, Row, Col, Breadcrumb, Tab, Tabs } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { calculatorGroups, getCalculatorGroup } from "../data/calculators";
import NotFound from "./NotFound";

function Block({ b }) {
  if (b.type === "h2") return <h2>{b.text}</h2>;
  if (b.type === "p") return <p>{b.text}</p>;
  if (b.type === "ul")
    return <ul>{b.items.map((it, i) => <li key={i}>{it}</li>)}</ul>;
  return null;
}

function CalculatorDetail() {
  const { slug } = useParams();
  const group = getCalculatorGroup(slug);
  if (!group) return <NotFound />;

  const others = calculatorGroups.filter((g) => g.slug !== group.slug);

  return (
    <Container className="py-4">
      <Breadcrumb listProps={{ className: "small mb-3" }}>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/calculators" }}>Calculators</Breadcrumb.Item>
        <Breadcrumb.Item active>{group.name}</Breadcrumb.Item>
      </Breadcrumb>

      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title" style={{ borderLeftColor: group.color }}>
            <span className="calc-title-icon" style={{ background: group.color }}>{group.icon}</span>
            {group.name}
          </h2>

          {/* Tab view of calculators in this group */}
          <div className="panel-calc mb-4" style={{ borderTopColor: group.color }}>
            <Tabs defaultActiveKey={group.items[0].key} className="calc-tabs mb-4" justify>
              {group.items.map((it) => {
                const C = it.Component;
                return (
                  <Tab eventKey={it.key} title={it.title} key={it.key}>
                    <C />
                  </Tab>
                );
              })}
            </Tabs>
          </div>

          {/* About / details */}
          <article className="article">
            <div className="article-inner">
              <h2>About {group.name}</h2>
              {group.about.map((b, i) => <Block key={i} b={b} />)}
              <div className="disclaimer-box mt-3">
                <strong>Disclaimer:</strong> Results are estimates for informational
                purposes only. Confirm exact figures with your bank or a financial advisor.
              </div>
            </div>
          </article>

          {/* Other calculator groups */}
          <h2 className="block-title mt-5">Other Calculators</h2>
          <Row className="g-3">
            {others.map((g) => (
              <Col sm={6} md={4} key={g.slug}>
                <Link to={`/calculators/${g.slug}`}>
                  <div className="calc-mini-card">
                    <span className="calc-mini-icon" style={{ background: g.color }}>{g.icon}</span>
                    <span className="fw-bold small">{g.name}</span>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Col>

        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default CalculatorDetail;
